import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Link, graphql, useStaticQuery } from 'gatsby';

import Body from '@bitcoin-portal/verse-web-components/dist/Body';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import Tile from '@components/Tile';
import H3 from '@components/atoms/H3';

import { useTrackedState } from '@context/store';

import { useTrackEvent } from '@hooks/useTrackEvent';

import { ContentWrapper, TitleWrapper, Wrapper } from './styled';

const Discounts = () => {
  const trackEvent = useTrackEvent();
  const { isWallet } = useTrackedState();
  const { messages } = useIntl();

  const tiles = messages['lounge.discounts.tiles'] as unknown as {
    id: string;
    subtitle: string;
    title: string;
    description: string;
    exclusive: boolean;
    link?: string;
  }[];

  const query = useStaticQuery(graphql`
    query DiscountImages {
      allFile(filter: { relativeDirectory: { eq: "lounge/discounts" } }) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(width: 340)
            }
          }
        }
      }
    }
  `);

  return (
    <Wrapper>
      <TitleWrapper>
        <H3>
          <FormattedMessage id="lounge.discounts.title" />
        </H3>
        <Body style={{ color: colors.shade80 }}>
          <FormattedMessage id="lounge.discounts.subtitle" />
        </Body>
      </TitleWrapper>
      <ContentWrapper>
        {tiles.map(({ id, subtitle, title, description, link, exclusive }) => {
          const linkAttrs = link?.startsWith('https')
            ? {
                as: 'a',
                href: `${link}${isWallet ? '?origin=wallet' : ''}`,
                target: isWallet ? '_self' : '_blank',
                onClick: () => {
                  trackEvent('tap', {
                    to: link,
                  });
                },
              }
            : {
                as: Link,
                to: link,
                onClick: () => {
                  trackEvent('tap', {
                    to: link,
                  });
                },
              };

          const image = query.allFile.edges.find(
            (edge: any) => edge.node.name === id,
          ).node.childImageSharp.gatsbyImageData;

          return (
            <Tile
              key={title}
              subtitle={subtitle}
              title={title}
              description={description}
              background={image}
              exclusive={!!exclusive}
              {...(exclusive ? {} : linkAttrs)}
            />
          );
        })}
      </ContentWrapper>
    </Wrapper>
  );
};

export default Discounts;
